// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controller-area[data-v-a064e596]{position:absolute;bottom:9%;right:5px}.outer[data-v-a064e596]{width:inherit;height:inherit}.thermal-camera-view[data-v-a064e596]{width:100%;height:100%;background-color:#000}", ""]);
// Exports
module.exports = exports;
